import "./SubMenuNavbar.scss";

import React, { useEffect, useRef, useState } from "react";

import { ChevronDown } from "@/assets/svg/svgIcons";

import ElementNavBar from "../ElementNavbar/ElementNavbar";
import { NavItemType } from "../Navbar";

interface SubMenuNavbarProps {
  navItem: NavItemType;
  openParent?: boolean;
  showLinkLogo?: boolean;
  toggleNavbar?: () => void;
  isTopNavbar?: boolean;
  isOpen?: boolean;
  onToggle?: () => void;
}

const SubMenuNavbar: React.FC<SubMenuNavbarProps> = ({
  navItem,
  openParent = true,
  showLinkLogo = true,
  toggleNavbar,
  isTopNavbar = false,
  isOpen,
  onToggle,
}) => {
  const [internalOpen, setInternalOpen] = useState(true);
  const dropdownRef = useRef<HTMLLIElement>(null);

  const open = isTopNavbar ? (isOpen ?? false) : internalOpen;

  useEffect(() => {
    if (!isTopNavbar) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        onToggle?.();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTopNavbar, open, onToggle]);

  if (!navItem.submenu) return null;

  const handleToggle = () => {
    if (isTopNavbar && onToggle) {
      onToggle();
    } else {
      setInternalOpen((prev) => !prev);
    }
  };

  if (isTopNavbar) {
    return (
      <li
        ref={dropdownRef}
        className={`submenu-container ${open ? "open" : ""}`}
      >
        <button
          className="submenu-toggle"
          onClick={handleToggle}
          aria-expanded={open}
        >
          {navItem.icon && navItem.icon}
          <span className="link-text">{navItem.text}</span>
          <span className={`chevron ${open ? "open" : ""}`}>
            <ChevronDown />
          </span>
        </button>

        {open && (
          <ul className="submenu-dropdown">
            {navItem.submenu.map((item) => (
              <ElementNavBar
                key={item.href + item.text}
                navItem={item}
                open={true}
                showLinkLogo={showLinkLogo}
                onLinkClick={() => {
                  onToggle?.();
                  toggleNavbar?.();
                }}
              />
            ))}
          </ul>
        )}
      </li>
    );
  }

  return (
    <li className={`nav-item submenu-navbar ${open ? "open" : "closed"}`}>
      <div
        className="submenu-header nav-link"
        onClick={handleToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleToggle();
          }
        }}
        tabIndex={0}
        role="button"
        aria-expanded={open}
      >
        {navItem.icon && navItem.icon}
        {openParent && <span className="link-text">{navItem.text}</span>}
        <span className={`chevron ${open ? "open" : ""}`}>
          <ChevronDown />
        </span>
      </div>

      <ul className={`submenu-list ${open ? "open" : ""}`}>
        {navItem.submenu.map((item) => (
          <ElementNavBar
            key={item.href + item.text}
            navItem={item}
            open={openParent}
            showLinkLogo={showLinkLogo}
            onLinkClick={toggleNavbar}
          />
        ))}
      </ul>
    </li>
  );
};

export default SubMenuNavbar;
